import type { PreferenceEmphasis } from '@travel-planner/shared/schemas';

/** Slider positions for each emphasis bucket (server re-rank). */
export const EMPHASIS_TO_VALUE: Record<PreferenceEmphasis, number> = {
  low: 25,
  normal: 50,
  high: 90,
};

export const emphasisToValue = (emphasis: PreferenceEmphasis): number =>
  EMPHASIS_TO_VALUE[emphasis];

export const valueToEmphasis = (value: number): PreferenceEmphasis => {
  if (value <= 33) return 'low';
  if (value >= 67) return 'high';
  return 'normal';
};

/** Per-tag slider value; falls back to emphasis bucket when legacy state. */
export const hashtagWeightFor = (
  weights: Record<string, number> | undefined,
  tag: string,
  emphasis: PreferenceEmphasis
): number => weights?.[tag] ?? emphasisToValue(emphasis);

export const isSelectedPreference = (
  preferenceEmphasis: Record<string, PreferenceEmphasis>,
  tag: string
): boolean => tag in preferenceEmphasis;
